import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useParams } from 'react-router';
import { Badge, notification, Dropdown, Menu } from 'antd';

import TimeAgo from 'javascript-time-ago';

import {
  unsetActiveChat,
  updateProjectPreferences,
  toggleDuplicateProjectModal,
  toggleNewProjectModal,
  toggleNewTeamChatsModal,
  isTicketOpen,
} from '../../../../actions';

import {
  isChatOpen,
} from '../../../../actions/toggleAction';
import { setRoomId } from '../../../../actions/roomAction';

import HtmlRenderer from '../../organisms/HtmlRenderer';

import {
  RESET_COUNTER,
  UPDATE_CURRENT_RECEIVER,
} from '../../../../actions/types/chat.types';

import '../../../../assets/style/chatTextArea.css';

import { updateChatRoomMessagesReadBy } from '../../../../actions/chatRoomAction';

import {
  clearMessagesState,
  updateQueryState,
} from '../../../../actions/messageAction';

import Stepper from '../../atoms/side-navbar/Stepper';
import UserAvatar from '../../atoms/ticket-drawer/UserAvatar';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  getLocalizedActivity,
} from '../../../../_locale/localesLookupTable';
import { Stack, Skeleton } from '@mui/material';
import useNavigateWithPersistedParams from '../../../../js/useNavigateWithPersistedParams';
import SearchNavBarHeader from './SearchNavBarHeader';
import { pinItemToWorkspace } from '../../../../actions/userAction';
import { getProjectColourPalette, getWorkspacePalette } from '../../../../js/helper';
import PinnedRow from './PinnedRow';

const NavBarContainer = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateWithPersistedParams = useNavigateWithPersistedParams();
  const params = useParams();

  const {
    currentWorkspace,
    workspaces,
    toggle,
    activeChat,
    selectedLeftNav,
    project,
    notifications,
    myProjects,
    projectLoading,
    pinnedItems,
    isGuest,
    setSidebarOpen,
  } = props;

  const intl = useIntl();

  const isListView = useSelector((state) => state.toggleReducer.isListView);
  const myProjectsIsLoaded = useSelector(
    (state) => state.projectReducer.isLoaded,
  );
  const chatIsLoaded = useSelector((state) => state.chatReducer.isLoaded);
  const [chatCollaps, setChatCollaps] = useState(true);
  const [pinnedCollaps, setPinnedCollaps] = useState(true);
  const [isPinnedActive, setIsPinnedActive] = useState(false);
  const [workSpaceCollaps, setWorkSpaceCollaps] = useState({
    isWorkSpace: true,
  });

  const [isLoading, setIsLoading] = useState(true);
  const [showSearch, setShowSearch] = useState({
    projects: false,
    pinned: false,
  });
  const [searchValue, setSearchValue] = useState({
    projects: '',
    pinned: '',
  });
  const [allItems, setAllItems] = useState({
    pinned: [],
    projects: [],
  });
  const [filteredItems, setFilteredItems] = useState({
    pinned: [],
    projects: [],
  });

  useEffect(() => {
    setAllItems(prev => ({ ...prev, pinned: pinnedItems || [] }));
    setFilteredItems(prev => ({ ...prev, pinned: pinnedItems || [] }));
  }, [pinnedItems]);

  useEffect(() => {
    setAllItems(prev => ({ ...prev, projects: myProjects || [] }));
    setFilteredItems(prev => ({ ...prev, projects: myProjects || [] }));
  }, [myProjects]);


  useEffect(() => {
    if (currentWorkspace && currentWorkspace._id) {
      setIsLoading(false);
    }
  }, [props.teams, currentWorkspace, workspaces]);

  const [size, setSize] = useState({
    height: Number(localStorage.getItem('height')) || 230,
  });

  const minimizeTeamsPanel = () => {
    workSpaceCollaps.isWorkSpace
      ? setSize({ height: 75 })
      : setSize({
        height: Number(localStorage.getItem('height'))
          ? Number(localStorage.getItem('height'))
          : 230,
      });
    setWorkSpaceCollaps({
      ...workSpaceCollaps,
      isWorkSpace: !workSpaceCollaps.isWorkSpace,
    });
  };

  useEffect(() => {
    if (activeChat) {
      navigateWithPersistedParams(`/chat/${activeChat}`);
      dispatch(unsetActiveChat());
    }
  }, [activeChat]);

  useEffect(() => {
    if (project) {
      navigateWithPersistedParams(`/${project._id}/${isListView ? 'list' : 'board'}`);
    }
  }, [project]);

  const setShowProjectModal = (value) => {
    dispatch(
      toggleNewProjectModal({
        value: value,
      }),
    );
    if (value) setSidebarOpen?.(false);
  };

  const setIsTeamsChatModalOpen = (value, isTeams) => {
    dispatch(
      toggleNewTeamChatsModal({
        value: value,
        isTeams: isTeams,
      }),
    );
  };

  const handleSearch = (type, val, fields) => {
    setSearchValue(prev => ({ ...prev, [type]: val }));

    const searchValue = val?.toLowerCase?.() || '';

    if (!searchValue) {
      setFilteredItems(prev => ({ ...prev, [type]: allItems[type] }));
      return;
    }

    const filtered = allItems[type]?.filter(item =>
      fields.some(field => {
        const fieldValue = item?.[field];
        return typeof fieldValue === 'string' && fieldValue.toLowerCase().includes(searchValue);
      })
    ) || [];

    setFilteredItems(prev => ({ ...prev, [type]: filtered }));
  };

  const isActivity = selectedLeftNav === 'Activity';
  const isHome = selectedLeftNav === 'Home' || isActivity;
  const isTeams = selectedLeftNav === 'Projects';
  const isPinned = selectedLeftNav === 'Pinned';
  const isChats = selectedLeftNav === 'Chats';

  return (
    <div style={{ height: !isHome ? '100%' : 'auto' }}>
      {(isPinned || isHome) && pinnedItems?.length > 0 && (
        <div
          style={{
            paddingLeft: toggle ? '' : '15px',
            paddingRight: toggle ? '' : '15px',
          }}
          className={`NavBarContainer 
          ${pinnedCollaps ? 'dropDownShow' : 'dropDownCollaps'}`}
        >
          <div>
            <div className="hor-line" />
            {showSearch?.pinned ? (
              <SearchNavBarHeader
                value={searchValue?.pinned}
                onChange={(val) =>
                  handleSearch('pinned', val, ['title', 'name'])
                }
                onClose={() => {
                  setShowSearch(prev => ({ ...prev, pinned: false }));
                  setSearchValue(prev => ({ ...prev, pinned: '' }));
                  setFilteredItems(prev => ({ ...prev, pinned: allItems.pinned }));
                }}
              />
            ) : (
              <div className="d-flex align-center justify-content-between disable-select h-[38px] ml-2">
                <div
                  className="d-flex align-center cursor-pointer"
                  onClick={() => setPinnedCollaps(prevPinnedCollaps => !prevPinnedCollaps)}
                >
                  <img
                    src="/images/icons/downArrowWhite.svg"
                    className={`transition-transform duration-300 ${pinnedCollaps ? "rotate-0" : "-rotate-90"
                      }`}
                    style={{
                      height: '10px',
                      width: '10px',
                      margin: '0 10px 0 5px',
                    }}
                    alt="icon"
                  />
                  <div
                    className="heading-nav font-16 text-white font-black"
                  >
                    <FormattedMessage id="PINNED" defaultMessage="Pinned" />
                  </div>
                </div>
                <div className="flex">
                  <div onClick={() => setShowSearch((prev) => ({ ...prev, pinned: true }))} className="flex items-center justify-center size-7 cursor-pointer hover:bg-slate-600 rounded py-1 px-0.5">
                    <img
                      src="/images/icons/search-black.svg"
                      height={14}
                      width={14}
                      alt="icon"
                      style={{ filter: "invert(1) brightness(500%)" }}
                    />
                  </div>
                </div>
              </div>)}
            <div
              className={`scroll-y disable-select mb-2`}
              style={{
                display: pinnedCollaps ? 'block' : 'none',
              }}
            >
              {filteredItems?.pinned?.length > 0 &&
                filteredItems?.pinned?.map((pinned, index) => {
                  if (!pinned?._id) {
                    return;
                  }
                  return (
                    <PinnedRow
                      allProjects={props?.allProjects}
                      chats={props?.chats}
                      pinned={pinned}
                      isPinnedActive={isPinnedActive}
                      setIsPinnedActive={setIsPinnedActive}
                      index={index}
                      currentWorkspace={props?.currentWorkspace} />
                  );
                })}
            </div>
          </div>
        </div>
      )}
      {!myProjectsIsLoaded && (
        <div className="ml-2 mb-2">
          <Stack spacing={1} p={1} mx={1}>
            {[...Array(4)].map((_, index) => (
              <Skeleton
                key={index}
                width="100%"
                height={20}
                sx={{ bgcolor: 'grey.800' }}
              />
            ))}
          </Stack>
        </div>
      )}
      {(isTeams || isHome) && (
        <div
          style={{
            paddingLeft: toggle ? '' : '15px',
            paddingRight: toggle ? '' : '15px',
          }}
          className={`NavBarContainer 
          ${workSpaceCollaps.isWorkSpace ? 'dropDownShow' : 'dropDownCollaps'} 
          ${!isHome && 'hide-border'}}`}
        >
          <div>
            <div className="hor-line" />
            {showSearch?.projects ? (
              <SearchNavBarHeader
                value={searchValue?.projects}
                onChange={(val) =>
                  handleSearch('projects', val, ['title', 'name'])
                }
                onClose={() => {
                  setShowSearch(prev => ({ ...prev, projects: false }));
                  setSearchValue(prev => ({ ...prev, projects: '' }));
                  setFilteredItems(prev => ({ ...prev, projects: allItems.projects }));
                }}
              />
            ) : (
              <div className="d-flex align-center justify-content-between disable-select h-[38px] ml-2">
                <div
                  className="d-flex align-center cursor-pointer"
                  onClick={() => minimizeTeamsPanel()}
                >
                  <img
                    src="/images/icons/downArrowWhite.svg"
                    className={`transition-transform duration-300 ${workSpaceCollaps.isWorkSpace ? "rotate-0" : "-rotate-90"}`}
                    style={{
                      height: '10px',
                      width: '10px',
                      margin: '0 10px 0 5px',
                    }}
                    alt="icon"
                  />
                  <div className="heading-nav font-16 text-white font-black">
                    <FormattedMessage id="PROJECTS" defaultMessage="Projects" />
                  </div>
                </div>
                <div className="flex">
                  <div onClick={() => setShowSearch((prev) => ({ ...prev, projects: true }))} className="flex items-center justify-center size-7 cursor-pointer hover:bg-slate-600 rounded py-1 px-0.5">
                    <img
                      src="/images/icons/search-black.svg"
                      height={14}
                      width={14}
                      alt="icon"
                      style={{ filter: "invert(1) brightness(500%)" }}
                    />
                  </div>
                  {!isGuest && <Dropdown
                    trigger={['click']}
                    menu={{
                      items: [
                        {
                          key: 'add-projects',
                          label: (
                            <div className="p-2 font-md">
                              {intl.formatMessage({
                                id: 'ADD_PROJECT',
                                defaultMessage: 'Add Project',
                              })}
                            </div>
                          ),
                          onClick: () => setShowProjectModal(true),
                        },
                        {
                          key: 'browse-projects',
                          label: (
                            <div className="p-2 font-md">
                              {intl.formatMessage({
                                id: 'BROWSE_PROJECTS',
                                defaultMessage: 'Browse Project',
                              })}
                            </div>
                          ),
                          onClick: () => navigate('/browse-projects'),
                        },
                      ],
                    }}
                    arrow
                    placement="bottomRight"
                  >
                    <div className="flex size-7 items-center justify-center cursor-pointer hover:bg-slate-600 rounded p-1">
                      <img
                        src="/images/icons/add.svg"
                        height={12}
                        width={12}
                        alt="icon"
                      />
                    </div>
                  </Dropdown>}
                </div>
              </div>)}
            <div
              className={`scroll-y disable-select mb-2`}
              style={{
                display: workSpaceCollaps.isWorkSpace ? 'block' : 'none',
              }}
            >
              {filteredItems?.projects?.length > 0
                ? filteredItems?.projects?.map((project, index) => {
                  if (!project?.title || project?.archived) {
                    return;
                  }

                  const me = project?.participants?.find(
                    (mem) =>
                      mem?._id?.toString() == props.user?._id?.toString(),
                  );

                  const updateProjPreferences = async () => {
                    await dispatch(
                      updateProjectPreferences({
                        ...me,
                        notifications: !me?.notifications,
                        projectId: project?._id,
                      }),
                    );
                  };

                  return (
                    <div key={project?._id + index}>
                      <Dropdown
                        menu={{
                          items: [
                            {
                              key: project?._id + '1',
                              label: (
                                <div className="text-slate-600 font-14 p-2">
                                  <FormattedMessage
                                    id="COPY_PROJECT_LINK"
                                    defaultMessage="Copy Project Link"
                                  />
                                </div>
                              ),
                              onClick: () => {
                                navigator.clipboard.writeText(
                                  `${window.location.origin}/${project._id}/board`,
                                );
                                notification.success({
                                  message: intl.formatMessage({
                                    id: 'PROJECT_LINK_COPIED',
                                    defaultMessage:
                                      'Project link copied to clipboard',
                                  }),
                                  placement: 'bottomRight',
                                });
                              },
                            },
                            {
                              key: project?._id + '2',
                              label: (
                                <div className="text-slate-600 font-14 p-2">
                                  {me?.notifications ? (
                                    <FormattedMessage
                                      id="UNMUTE_PROJECT"
                                      defaultMessage="Unmute Project"
                                    />
                                  ) : (
                                    <FormattedMessage
                                      id="MUTE_PROJECT"
                                      defaultMessage="Mute Project"
                                    />
                                  )}
                                </div>
                              ),
                              onClick: async () => {
                                updateProjPreferences();
                              },
                            },
                            {
                              key: project?._id + '3',
                              label: (
                                <div className="text-slate-600 font-14 p-2">
                                  <FormattedMessage
                                    id="DUPLICATE_PROJECT"
                                    defaultMessage="Duplicate Project"
                                  />
                                </div>
                              ),
                              onClick: () => {
                                dispatch(
                                  toggleDuplicateProjectModal(true, project),
                                );
                              },
                            },
                            {
                              key: project?._id + '4',
                              label: (
                                <div className="text-indigo-600 font-14 p-2">
                                  <FormattedMessage
                                    id="PROJECT_SETTINGS"
                                    defaultMessage="Project Settings"
                                  />
                                </div>
                              ),
                              onClick: () => {
                                navigateWithPersistedParams(`/${project?._id}/settings`);
                              },
                            },
                            {
                              key: project?._id + '5',
                              label: (
                                <div className="text-slate-600 font-14 p-2">
                                  {!project?.pinned ?
                                    <FormattedMessage
                                      id="ADD_TO_PINNED"
                                      defaultMessage="Add to Pinned"
                                    /> : <FormattedMessage
                                      id="REMOVE_FROM_PINNED"
                                      defaultMessage="Remove from Pinned"
                                    />}
                                </div>
                              ),
                              onClick: () => {
                                dispatch(pinItemToWorkspace({
                                  entityId: project?._id,
                                  entityType: "project",
                                  workspaceId: props?.currentWorkspace?._id,
                                }, !project?.pinned, project))
                              }
                            },
                          ],
                        }}
                        trigger={['contextMenu']}
                      >
                        <div
                          onClick={() => { setIsPinnedActive(false); navigateWithPersistedParams(`/${project?._id}/${localStorage.getItem('projectLastView') || 'board'}`) }}
                          className={`d-flex justify-between cursor-pointer align-center hover:bg-[#394867] w-full py-2 px-3 rounded my-0.5 ${!isPinnedActive && (params?.projectid === project?._id) && 'nav-item-active'}`}
                        >
                          <div className="flex align-center truncate pr-3">
                            <div className='size-4 flex-shrink-0 flex rounded ml-1 mr-1' style={{ background: getProjectColourPalette(project?.metadata?.colour).bg, border: `1px solid ${getProjectColourPalette(project?.metadata?.colour).border}` }} />
                            <span className="ml-1 truncate font-14">
                              {project?.title}
                            </span>
                          </div>
                          {project?.access !== 'public' && (
                            <img
                              src={`/images/icons/white-lock.svg`}
                              className="h-4 w-4 mr-1"
                              alt="icon"
                            />
                          )}
                        </div>
                      </Dropdown>
                    </div>
                  );
                })
                : !isLoading &&
                !showSearch?.projects &&
                !projectLoading && (
                  <Stepper
                    items={[
                      {
                        label: intl.formatMessage({
                          id: 'BROWSE_PROJECTS',
                          defaultMessage: 'Browse Projects',
                        }),
                        onPress: () => {
                          navigate('/browse-projects')
                        },
                      },
                      {
                        label: intl.formatMessage({
                          id: isGuest ? 'NO_PROJECTS' : 'CREATE_PROJECT',
                          defaultMessage: 'Create Project',
                        }),
                        onPress: () => {
                          !isGuest && setShowProjectModal(true);
                        },
                      },
                    ]}
                    line={20}
                  />
                )}
            </div>
          </div>
        </div>
      )}
      {!myProjectsIsLoaded && (
        <div className="ml-2 mb-2">
          <Stack spacing={1} p={1} mx={1}>
            {[...Array(4)].map((_, index) => (
              <Skeleton
                key={index}
                width="100%"
                height={20}
                sx={{ bgcolor: 'grey.800' }}
              />
            ))}
          </Stack>
        </div>
      )}
      {/* chat collaps .................................................................*/}
      {(isChats || isHome) && (
        <div
          className={`NavBarContainer ${chatCollaps ? 'dropDownShow' : 'dropDownCollaps'
            }`}
          style={{
            paddingLeft: toggle ? '10px' : '15px',
            paddingRight: toggle ? '10px' : '15px',
            paddingBottom: 10,
          }}
        >
          <div>
            <div className="hor-line" />
            <div
              className="d-flex align-center justify-content-between h-[38px] ml-2 mt-3"
              style={{ paddingBottom: 10 }}
            >
              <div
                className="d-flex align-center cursor-pointer"
                onClick={() => setChatCollaps(!chatCollaps)}
              >
                <img
                  src="/images/icons/downArrowWhite.svg"
                  className={`transition-transform duration-300 ${chatCollaps ? "rotate-0" : "-rotate-90"}`}
                  style={{
                    height: '10px',
                    width: '10px',
                    margin: '0 10px 0 5px',
                  }}
                  alt="icon"
                />
                <div className="heading-nav font-16 text-white font-black">
                  <FormattedMessage id="CHATS" defaultMessage="Chats" />
                </div>
              </div>
              {!isGuest && <div className="d-flex align-center cursor-pointer hover:bg-slate-600 rounded p-1 mr-1" onClick={() => setIsTeamsChatModalOpen(true, false)}>
                <img
                  src="/images/icons/add.svg"
                  height={12}
                  width={12}
                  alt="icon"
                />
              </div>}
            </div>
          </div>
          {/* .........................Chat area.......................... */}
          {!chatIsLoaded && (
            <div className="">
              <Stack spacing={1} p={1} ml={1}>
                {[...Array(6)].map((_, index) => (
                  <Skeleton
                    key={index}
                    width="100%"
                    height={20}
                    sx={{ bgcolor: 'grey.800' }}
                  />
                ))}
              </Stack>
            </div>
          )}
          {chatCollaps && (
            <ul className="overflow-x-hidden">
              {props?.chats &&
                props?.chats.map((chat, i) => {
                  const isDirectChat = chat.roomType === 'direct';
                  const isProjectChat = chat.roomType === 'project';

                  const dmUser = chat.members?.filter(
                    (memeber) => memeber._id !== localStorage.getItem('Id'),
                  );
                  const name =
                    isDirectChat && !isProjectChat
                      ? dmUser[0]?.fullName || 'User'
                      : chat.roomName;
                  const avi = isDirectChat ? dmUser[0]?.avi : chat.roomAvi;
                  const mostRecentMessage = chat.mostRecentMessage || '';

                  const currentMessageDate = new Date(
                    chat?.lastUpdate,
                  ).toLocaleDateString('en-us', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                  });

                  const iconLetters = name?.slice(0, 2).toUpperCase() || '';

                  let span = document.createElement('span');
                  span.innerHTML = mostRecentMessage?.messageDescription;
                  const htmlContent = span.textContent || span.innerText;

                  const hasNotification = chat.count > 0;
                  const substringLength = hasNotification ? 25 : 35;

                  if (isProjectChat || !name) {
                    return;
                  }
                  if (isDirectChat && !dmUser[0]?.fullName) {
                    return;
                  }
                  const isPinnedChat = pinnedItems?.some(item => (item?.entity === "chat" || item?.roomType) && item?._id === chat?._id);

                  return (
                    <Dropdown
                      menu={{
                        items: [
                          {
                            key: chat?._id + '1',
                            label: (
                              <div className="text-slate-600 font-14 p-2">
                                {!isPinnedChat ?
                                  <FormattedMessage
                                    id="ADD_TO_PINNED"
                                    defaultMessage="Add to Pinned"
                                  /> : <FormattedMessage
                                    id="REMOVE_FROM_PINNED"
                                    defaultMessage="Remove from Pinned"
                                  />}
                              </div>
                            ),
                            onClick: () => {
                              dispatch(pinItemToWorkspace({
                                entityId: chat?._id,
                                entityType: "chat",
                                workspaceId: props?.currentWorkspace?._id,
                              }, !isPinnedChat, { ...chat, name, avi }))
                            }
                          },
                        ],
                      }}

                      trigger={['contextMenu']}
                    >
                      <li
                        key={chat?._id}
                        className={`flex px-2 py-0.5 mb-1 cursor-pointer align-center nav-bar-chat ${!isPinnedActive && params?.chatId?.toString() === chat?._id?.toString() && 'nav-item-active'} ${hasNotification && 'font-bold'}`}
                        onClick={() => {
                          setIsPinnedActive(false);
                          if (
                            params?.chatId?.toString() != chat?._id?.toString()
                          ) {
                            dispatch(updateQueryState(1));
                            dispatch(clearMessagesState());
                            dispatch(setRoomId(chat._id));
                            dispatch({
                              type: RESET_COUNTER,
                              payload: chat._id,
                            });
                            navigateWithPersistedParams(`/chat/${chat._id}`);
                            dispatch({
                              type: UPDATE_CURRENT_RECEIVER,
                              payload: chat.roomName,
                            });
                          }
                          dispatch(
                            updateChatRoomMessagesReadBy(
                              chat._id,
                              'ChatsNavBar1',
                            ),
                          );
                        }}
                      >
                        <div className="flex align-center">
                          {isDirectChat ? (
                            <UserAvatar
                              classNames="my-1 mr-2 w-6 h-6 ml-1"
                              fullName={dmUser[0]?.fullName}
                              userId={dmUser[0]?._id}
                              src={dmUser[0]?.avi}
                              styles={{
                                objectFit: 'cover',
                                borderRadius: 6,
                                border: '2px solid transparent',
                                aspectRatio: 1,
                              }}
                            />
                          ) : avi ? (
                            <img
                              src={avi}
                              className="my-1 mr-2 w-6 h-6 ml-1"
                              style={{
                                objectFit: 'cover',
                                borderRadius: 6,
                                aspectRatio: 1,
                              }}
                              alt="icon"
                            />
                          ) : (() => { const p = getWorkspacePalette(name); return (
                            <div
                              className="my-1 mr-2 w-6 h-6 ml-1 flex-shrink-0 flex items-center justify-center text-[9px] font-bold"
                              style={{ borderRadius: 6, background: p.bg, border: `1px solid ${p.border}`, color: p.text, letterSpacing: '0.04em' }}
                            >
                              {iconLetters}
                            </div>
                          ); })()}
                          <div>
                            <div
                              className={`font-14 leading-5 self-center truncate ${hasNotification && 'font-bold'}`}
                            >
                              {name?.substring(0, hasNotification ? 20 : 25)}
                            </div>
                            {/* {htmlContent !== 'undefined' && <div className={`font-12 leading-2 truncate max-w-[80%] ${hasNotification && 'font-bold'}`} style={{ width: hasNotification ? 150 : 200 }}>
                        {htmlContent}
                      </div>} */}
                          </div>
                        </div>
                        {hasNotification && (
                          <div>
                            <Badge
                              count={chat.count || 0}
                              // count={0}
                              style={{
                                backgroundColor: '#FE3C32',
                                boxShadow: 'none',
                              }}
                            />
                          </div>
                        )}
                      </li>
                    </Dropdown>
                  );
                })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    toggle: state.navReducer.toggle,
    activeChat: state.chatReducer.activeChat,
    project: state.projectReducer.success,
    projectData: state.projectReducer.getProjects,
    projectLoading: state.projectReducer.loading,
    pinnedItems: state.userReducer.pinned,
    allProjects: state.workspaceReducer.workspaceProjects,
  };
}

export default connect(mapStateToProps)(NavBarContainer);
